export default __webpack_public_path__ + "static/hire-a-developer-scaled-6de5f7dd4477c0d8a1136d6657a5f140.jpg";